"use client";

import PaymentsModal from "@/features/payments/components/paymentsModal/paymentsModal";
import StorageExplorerModal from "@/features/storage/explorer/storageExplorerModal";
import PresentationSheet from "@/features/storage/sheets/presentationSheet/presentationSheet";
import VideoSheet from "@/features/storage/sheets/videoSheet/videoSheet";
import LomdaSheet from "@/features/storage/sheets/lomdaSheet/lomdaSheet";
import LomdaV2Sheet from "@/features/storage/sheets/lomdaV2Sheet/lomdaV2Sheet";
import LomdaV3Sheet from "@/features/storage/sheets/lomdaV3Sheet/lomdaV3Sheet";
import { useMountedState } from "react-use";

interface ModalsProviderProps {
    modalsFor: "platform";
}

export default function ModalsProvider({ modalsFor }: ModalsProviderProps) {
    const isMounted = useMountedState();

    if (!isMounted) return null;

    if (modalsFor === "platform") {
        return (
            <>
                <StorageExplorerModal />
                <VideoSheet />
                <PresentationSheet />
                <LomdaSheet />
                <LomdaV2Sheet />
                <LomdaV3Sheet />
                <PaymentsModal />
            </>
        );
    }
}
